import React, { useEffect, useState } from "react";
import TableAHSF from "../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetReportByAppGuid } from "../../Redux/Reducers/ReportStage/Report";
import { encryptToken } from "../../Services/Account/EncryptionParams";
import ButtonAHSF from "../../Components/ButtonAHSF";

const ReportsStagesSubmitter = (props) => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const [currentStage, setCurrentStage] = useState();
  const [reportId, setReportId] = useState();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const navigate = useNavigate();
  //this method to تشفير ال param
  const encodeParam = (param) => btoa(param);
  const state = useSelector((state) => {
    return {
      ApplicationInformation: state.ApplicationInformation,
      loadingReportByApp: state.TypeOfJobOpportunityDropDown.loadingReportByApp,
    };
  });
  const RequestAccessor = [
    {
      KeyName: "stagesName",
      ShowStatus: true,
      NmaeColumn: "المرحله",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "startMonth",
      ShowStatus: true,
      NmaeColumn: "شهر البداية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "endMonth",
      ShowStatus: true,
      NmaeColumn: "شهر النهاية",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "implementationDurartion",
      ShowStatus: true,
      NmaeColumn: "مدة التنفيذ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusStagesName",
      ShowStatus: true,
      NmaeColumn: " حالة المرحلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        navigate(
          `/grants/ReportStageContainer/${encryptToken(e.target.value)}`
        );
      },
      content: "",
      className: "bi bi-pencil-square",
      className2: "bi bi-view-list",
      id: "editBtn",
      title: "",
      ShowStatus: true,
      currentStage: true,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div></div>,
    maxWidth: "100px",
    maxHeight: "100px",
  };

  const getReport = async () => {
    const report = await dispatch(
      GetReportByAppGuid({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
      })
    );
    if (report.payload) {
      console.log(report.payload);
      setReportId(report.payload?.pR_ReportsId);
      setCurrentStage(report.payload.pR_StagesNumberId);
    }
  };
  useEffect(() => {
    getReport();
  }, []);
  return (
    <div style={{ marginTop: "3%" }}>
      <ButtonAHSF
        type={"submitter"}
        onClick={() => {
          navigate(`/grants/ReportSummaryPage/${encryptToken(reportId)}`);
        }}
        disabled={false}
        title={"ملخص التقرير المرحلي"} // Arabic for "Next"
        text={"ملخص التقرير المرحلي"} // Arabic for "Next"
        show={true}
      />
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_ReportsStagesGuid"}
        valueButtonAction={"pR_ReportsStagesGuid"}
        URL={`api/PR_ReportsStages/GetListReportsStagesByApplicationInformationGUID`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"التقارير المرحلية"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        currentStage={currentStage}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={""}
      />

      {/* <LoaderAHSF show={!canClick} /> */}
    </div>
  );
};

export default ReportsStagesSubmitter;
